import { Reveal } from "./motion-primitives";

// Consistent editorial section heading with overline + serif title.
export const SectionHeading = ({ overline, title, intro, align = "left", testId }) => {
  const alignCls = align === "center" ? "items-center text-center mx-auto" : "items-start text-left";
  return (
    <div className={`flex flex-col ${alignCls} max-w-3xl`} data-testid={testId}>
      {overline && (
        <Reveal>
          <div className="mb-6 flex items-center gap-4">
            <span className="h-px w-10 bg-teal" />
            <span className="font-sans text-xs uppercase tracking-[0.3em] text-teal">
              {overline}
            </span>
          </div>
        </Reveal>
      )}
      <Reveal delay={0.05}>
        <h2 className="font-serif text-4xl font-light leading-[1.05] tracking-tight text-cream sm:text-5xl lg:text-6xl">
          {title}
        </h2>
      </Reveal>
      {intro && (
        <Reveal delay={0.12}>
          <p className="mt-6 max-w-xl font-sans text-base leading-relaxed text-sand sm:text-lg">
            {intro}
          </p>
        </Reveal>
      )}
    </div>
  );
};
